/** Max characters for the My Tasks row preview line before truncation. */
export const WORKSPACE_AGENT_SESSION_ROW_PREVIEW_MAX_LENGTH = 80;

/** Stable id for the portalled panel root. */
export const WORKSPACE_AGENT_PANEL_ELEMENT_ID = 'workspace-agent-panel';

/** Inner shell the bottom sheets anchor to. Overflow is clipped here, inside the card radius. */
export const WORKSPACE_AGENT_PANEL_BODY_ELEMENT_ID = 'workspace-agent-panel-body';

/** Live docked width for ui2026 — updated by resize and store sync. */
export const WORKSPACE_AGENT_PANEL_WIDTH_CSS_VARIABLE = '--workspace-agent-panel-width';

/**
 * In-flow width the upload dropzones subtract on the right: the docked spacer, plus the
 * ui2026 gutter beside the chrome card. 0px while that spacer is not mounted.
 */
export const WORKSPACE_AGENT_PANEL_SLOT_WIDTH_CSS_VARIABLE = '--workspace-agent-panel-slot-width';

/**
 * Marks the chat thread scrollport. The onboarding handoff pins this node. `scrollIntoView`
 * would walk up to the page and slide the fixed panel under the workspace header.
 */
export const WORKSPACE_AGENT_PANEL_CHAT_SCROLL_ATTRIBUTE = 'data-workspace-agent-chat-scroll';

/** One above Tailwind `z-portal` (`100000`). Matches `z-above-portal` in `createTailwindConfig`. */
export const WORKSPACE_AGENT_PANEL_ABOVE_PORTAL_Z_INDEX = 100001;

/** Pointer travel (px) before a header grab undocks the in-flow panel. Matches the Strato proto. */
export const WORKSPACE_AGENT_PANEL_DRAG_THRESHOLD_PX = 5;

/**
 * How close the floating card's trailing edge must sit to the viewport's right (px) before drop
 * snaps it back into the in-flow dock. Matches the Strato proto `SNAP_THRESHOLD`.
 */
export const WORKSPACE_AGENT_PANEL_SNAP_THRESHOLD_PX = 24;

/**
 * How far above the bottom (px) the reader must scroll before the jump-to-bottom control appears.
 * The same band is used for older-message prefetch near scrollTop === 0.
 * Prototype used 48px; production starts higher so small nudges off the tail do not show the button.
 */
export const WORKSPACE_AGENT_JUMP_TO_BOTTOM_THRESHOLD_PX = 400;

/**
 * After jump smooth scroll, only run an instant virtualizer tail align when farther than this from
 * the bottom — avoids a visible snap when remeasure leaves a small scroll gap.
 */
export const WORKSPACE_AGENT_JUMP_TO_BOTTOM_CATCH_UP_MIN_GAP_PX = 48;

/**
 * Default page size for `Agents.Sessions.Messages.list` when the client omits `limit` (backend
 * `listMessages` uses `limit = 50`, max 500).
 */
export const WORKSPACE_AGENT_SESSION_MESSAGES_LIST_DEFAULT_LIMIT = 50;

/** Shown in the task header and task list when a session has no title from the API yet. */
export const WORKSPACE_AGENT_DEFAULT_SESSION_TITLE = 'New task';

/**
 * Mirrors `Header`'s `h-12`, in rem rather than px so it tracks that class at any root font size.
 * Used for interim below-the-header panel geometry over the asset view — see
 * `useWorkspaceAgentPanelViewport`.
 *
 * @TODO(WORK-174): Remove alongside the panel's interim below-the-header geometry.
 */
export const WORKSPACE_AGENT_PANEL_ASSET_VIEW_HEADER_TOP = '3rem';
